<template>
  <div class="register-user my-4"> 
    <div class="loader" v-if="loading"></div>
    <div class="">
    <div class="container h-100">
      <div class="row d-flex justify-content-center align-items-center h-100">
        <div class="">
          <div class="card" style="border-radius: 15px; width:700px;">
            <div class="card-body px-5 py-2">
              <h2 class="text-uppercase text-center mt-4 mb-5">{{ $t("register.title")}}</h2>

              <form>
                <div class="mb-4 row">
                  <label for="form3Example1cg" class="col-sm-4 col-form-label">{{ $t("register.name")}}</label>
                  <span class="w-full text-red-500" v-if="errors.name">{{errors.name[0]}}</span>
                  <div class="col-sm-8">
                    <input type="text" id="form3Example1cg" class="form-control" v-model="form.name"/>
                  </div>
                </div>
                <div class="mb-4 row">
                  <label for="form3Example2cg" class="col-sm-4 col-form-label">{{ $t("register.email")}}</label>
                  <div class="col-sm-8">
                    <input type="email" id="form3Example2cg" class="form-control" v-model="form.email"/>
                  </div>
                </div>
                <div class="mb-4 row">
                  <label for="form3Example3cg" class="col-sm-4 col-form-label">{{ $t("register.password")}}</label>
                  <div class="col-sm-8">
                    <input type="password" id="form3Example3cg" class="form-control" v-model="form.password" name="password"/>
                  </div>
                </div>
                <div class="mb-4 row">
                  <label for="form3Example4cg" class="col-sm-4 col-form-label">{{ $t("register.confirmPassword")}}</label>
                  <div class="col-sm-8">
                    <input type="password" id="form3Example4cg" class="form-control" v-model="form.password_confirmation" name="password_confirmation"/>
                  </div>
                </div>

              <div class="errors mb-2">
                  <p v-if="errors.length" style="color: red;">
                    <ul >
                      <li v-for="(error,idx) in this.errors" :key="idx">{{error}}</li>
                    </ul>
                  </p>
                </div>

                <!-- <div class="form-check d-flex justify-content-center mb-5">
                  <input style="position: relative; right: 5px;"
                    class="form-check-input me-2"
                    type="checkbox"
                    value=""
                    id="form2Example3cg"
                  />
                  <label class="form-check-label" for="form2Example3g">
                    I agree all statements in <a href="#!" class="text-body"><u>Terms of service</u></a>
                  </label>
                </div> -->
                <span v-if="msg.email">{{msg.email}}</span>
                <div class="d-flex justify-content-center">
                  <button @click.prevent="saveForm" type="submit" class="btn btn-success btn-block btn-lg gradient-custom-4 text-white">{{ $t("register.btnRegister")}}</button>
                </div>

                <p class="text-center text-muted mt-4 mb-3">{{ $t("register.alreadyhaveaccount")}} <label class="log fw-bold text-body" @click="goToRoute(routeNames.login)"><u>{{ $t("register.loginHere")}}</u></label></p>

              </form>

            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  </div>
</template>
<script>
import axios from 'axios';
import { routeNames } from '../js/routeNames';
// import { encryptData } from '../js/utils/encrypt';
export default {
  data() {
    return {
      form: {
        name: '',
        email: '',
        password: '',
        password_confirmation: '',
      },
      errors: [],
      loading: false,
      msg: [],
      loginForm: {
        email: '',
        password: '',
      },
      token: '',
      permissions: [],
      role: '',
      isAuthenticated: true,
    };
  },
  computed: {
    routeNames: () => {
      return routeNames;
    },
  },
  methods: {
    saveForm(e) {
      this.errors = [];
      if (
        this.form.name == '' ||
        this.form.email == '' ||
        this.form.password == '' ||
        this.form.password_confirmation == ''
      ) {
        if (this.form.name == '') {
          this.errors.push('Name required.');
        }
        if (this.form.email == '') {
          this.errors.push('Email required.');
        }
        if (this.form.password == '') {
          this.errors.push('Password required.');
        }
        if (this.form.password_confirmation == '') {
          this.errors.push('Password confirmation required.');
        }
        if (!this.errors.length) {
          return true;
        }
        e.preventDefault();
        return;
      }

      if (
        this.form.name != '' ||
        this.form.email != '' ||
        this.form.password != '' ||
        this.form.password_confirmation != ''
      ) {
        if (this.form.password.length < 6) {
          this.errors.push('Minimum 6 characters required.');
          return;
        }
        if (this.form.password != this.form.password_confirmation) {
          this.errors.push('Password and Confirm Password does not match');
          return;
        }
        if (this.form.email != '') {
          if (
            /^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/.test(this.form.email)
          ) {
            console.log('skip');
          } else {
            this.errors.push('Incorrect email format');
            return;
          }
        }
      }
      this.loginForm.email = this.form.email;
      this.loginForm.password = this.form.password;
      this.loading = true;
      axios
        .post(this.$hostName + '/register', this.form)
        .then((response) => {
          console.log('res', response);
          if (this.errors.name) {
            this.loading =  false;
            this.errors = [this.errors.name[0]];
            return;
          }
          else {
            this.loading =  false;
            // this.$alert('Registration Successful');
            localStorage.setItem('registered', true);
            this.$router.push({ name: routeNames.login });
            location.reload();
          }
        })
        .catch((error) => {
          this.errors = error.response.data.errors;
        });

      // axios
      //   .post(this.$hostName + '/login', this.loginForm)
      //   .then((response) => {

      //     //encrypted isAuthenticated
      //     const secretKey = process.env.KEY || 'myscecretkey';
      //     const encryptedData = encryptData(this.isAuthenticated, secretKey);
      //     localStorage.setItem('Login', encryptedData);

      //     this.token = response.data.data.token;

      //     //encrypted token
      //     const secretTokenKey = process.env.KEY || 'myscecretkey';
      //     const encryptedTokenData = encryptData(this.token, secretTokenKey);
      //     localStorage.setItem('token', encryptedTokenData);

      //     let data = Object.keys(response.data.data.permissions).map((key) => {
      //       return response.data.data.permissions[key].name;
      //     });
      //     this.permissions = data;
      //     this.role = response.data.data.roles[0];
      //     localStorage.setItem('username', JSON.stringify(this.form.name));

      //     //encrypt Permissions
      //     const secretPermissionKey = process.env.KEY || 'myscecretkey';
      //     const encryptedPermissionData = encryptData(
      //       this.permissions,
      //       secretPermissionKey
      //     );
      //     const encryptedRoleData = encryptData(this.role, secretPermissionKey);
      //     localStorage.setItem('Permissions', encryptedPermissionData);
      //     localStorage.setItem('Role', encryptedRoleData);

      //     this.$router.push({ name: routeNames.flightManager });
      //   })
      //   .catch((error) => {
      //     this.errors = error.response.data.errors;
      //   })
      //   .finally(() => {
      //     if (this.errors.name) {
      //       this.loading = false;
      //       this.errors = [this.errors.name[0]];
      //       return;
      //     } else {
      //       this.loading = false;
      //       location.reload();
      //     }
      //   });
    },
    goToRoute(route) {
      if (this.navOpen) this.toggleNav();
      if (route == this.$router.currentRoute.name) return;
      this.$router.push({ name: route });
    },
  },
};
</script>
<style scoped>
.container {
  position: absolute;
  left: 0;
  right: 60px;
  top: 0;
  bottom: 0;
  width: 1140px; /* Assign a value */
  height: 420px; /* Assign a value */
  margin: auto;
}
.log:hover {
  cursor: pointer;
}
.loader {
  /* Loader Div Class */
  position: absolute;
  top: 0px;
  right: 30px;
  width: 100%;
  height: 100%;
  background-color: #eceaea;
  background-image: url("../assets/loading.gif");
  background-size: 50px;
  background-repeat: no-repeat;
  background-position: center;
  z-index: 10000000;
  opacity: 0.4;
  filter: alpha(opacity=40);
}
</style>